import reducer from './classes/reducers';

import * as classesSelectors from './classes/selectors';
import * as classesActions from './classes/actions';
import * as classesTypes from './classes/types';

export {
  classesSelectors,
  classesActions,
  classesTypes,
};

export default reducer;
